/* eslint-disable no-nested-ternary */
import React from 'react';

import AttachFileIcon from '@mui/icons-material/AttachFile';

import { Typography } from '@mui/material';

import ReplayIcon from '@mui/icons-material/Replay';

import Box from '@mui/material/Box';

import { Button } from 'components/Button';

import { ActivityResponse, FileActivityResponse, FileUploadProgressResponse } from 'ui/types';

import { humanFileSize } from 'utils/formatters/file';

import { colors } from 'theme/colors';

import { FileUploadContainer, FileName, FileSize, StyledLinearProgress } from './styles';

function isFile(file: ActivityResponse): file is FileActivityResponse {
  return (file as FileActivityResponse).filename !== undefined;
}

const FileUpload: React.FC<{
  activity: ActivityResponse;
  failed?: boolean;
  retryUpload: (fileUuid: string) => Promise<void>;
}> = ({ activity, failed, retryUpload }) => {
  let size: number;
  let name: string;
  let loaded = 0;
  if (isFile(activity)) {
    size = activity.size;
    name = activity.filename;
  } else {
    const fileUploadProgress = activity as FileUploadProgressResponse;
    size = fileUploadProgress.size;
    name = fileUploadProgress.name;
    loaded = fileUploadProgress.loaded;
  }

  const progressValue = (loaded / size) * 100;

  return (
    <FileUploadContainer>
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex' }}>
          <AttachFileIcon sx={{ color: colors.text.secondary }} />
          <div>
            <FileName>{name}</FileName>
            {failed ? (
              <Typography variant="body2" color="red">
                Failed to upload
              </Typography>
            ) : (
              <FileSize>{humanFileSize(size)}</FileSize>
            )}
          </div>
        </Box>
        {failed ? (
          <Button onClick={() => retryUpload(activity.uuid)} style={{ padding: '0', minWidth: '0' }}>
            <ReplayIcon />
          </Button>
        ) : null}
      </Box>
      {failed ? null : (
        <Box sx={{ width: '100%', paddingTop: '9px' }}>
          <StyledLinearProgress variant="determinate" value={progressValue} $completed={progressValue >= 100} />
          <Typography variant="body2" color="text.secondary">
            {`${Math.round(progressValue)}%`}
          </Typography>
        </Box>
      )}
    </FileUploadContainer>
  );
};

export default FileUpload;
